module.exports = __webpack_public_path__ + "static/media/DSC_0195.cbd0922b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0195.jpg
// module id = 566
// module chunks = 0